import { waitUntil, getCookie, getSampleData } from '../utils'

class Join {
  constructor(options) {
    if (document.querySelector('#formsort')) {
      waitUntil(
        () => !!getCookie('hubspotutk') && !!getCookie('ajs_anonymous_id'),
        {
          interval: 100,
          retries: 10,
        }
      )
        .catch(() => {})
        .finally(() => {
          const params = {
            formsortEnv: options.isProduction ? 'production' : 'staging',
          }

          const hutk = getCookie('hubspotutk')
          if (hutk) params['hutk'] = hutk

          const utmCampaign = getCookie('utm_campaign')
          if (utmCampaign) {
            params['utm_campaign'] = utmCampaign
          }

          const ajsAnonymousId = getCookie('ajs_anonymous_id')
          if (ajsAnonymousId) {
            params['ajs_anonymous_id'] = ajsAnonymousId
          }

          const formsortArgs = {
            c: '0MetJjAx0M',
            f: 'smb-intake',
            o: { parentEl: '#formsort' },
            params,
          }

          const requestParams = new URLSearchParams(window.location.search)
          const variant = requestParams.get('v')
          const flowLabel = requestParams.get('f')
          const businessAddress = requestParams.get('business_address')
          const encodedBusinessAddress = requestParams.get('ba')
          if (variant) {
            formsortArgs['v'] = variant
          }
          if (flowLabel == 'lease-checkup') {
            formsortArgs['f'] = 'lease-checkup-smb-intake'
          }
          if (flowLabel == 'estimate') {
            formsortArgs['f'] = 'estimate-smb-intake'
          }

          if (encodedBusinessAddress) {
            params['business_address[raw]'] = atob(encodedBusinessAddress)
          } else if (businessAddress) {
            params['business_address[raw]'] = businessAddress
          }

          if (flowLabel == 'budget') {
            formsortArgs['f'] = 'budget-smb-intake'
          }

          const responderUuid = requestParams.get('responderUuid')
          if (responderUuid) {
            params['responderUuid'] = responderUuid
          }

          const prefill = requestParams.get('prefill') == 'false' ? false : true

          if (!options.isProduction && prefill) {
            const sampleData = getSampleData()

            params['responderUuid'] = crypto.randomUUID()
            params['first_name'] = sampleData.firstName
            params['last_name'] = sampleData.lastName
            params['email'] = sampleData.email
            params['phone'] = '6157520741'
            params['business_address[raw]'] =
              '54 Spring Street, Wilkes Barre, PA 18702, USA'
            params['business_address[address_1]'] = '54 Spring Street'
            params['business_address[city]'] = 'Wilkes Barre'
            params['business_address[state]'] = 'PA'
            params['business_address[postal_code]'] = '18702'
            params['business_address[country]'] = 'United States'
            params['invest_in_current_property'] = 'yes'
            params['business_name'] = sampleData.businessName
            params['year_founded'] = 2000
            params['business_industry'] = 'industrial'
            params['monthly_rent'] = 10000
            params['lease_expiration_date'] = '2026-01-09'
            params['monthly_revenue_estimate'] = 100000
            params['personal_credit_score'] = '800_to_850'
            params['sba_referral_opt_in'] = true
            params['hear_about_us'] = 'search'
          }

          _formsort.load(formsortArgs)

          this.attachEventListeners()
        })
    }
  }

  attachEventListeners() {
    // https://www.simoahava.com/analytics/cookieless-tracking-cross-site-iframes/#solution-2-forward-all-data-layer-messages-from-child-to-parent

    // iframeToParent.js is added to iframe via Google Tag Manager (https://tagmanager.google.com/#/container/accounts/6005711211/containers/57410340/workspaces/28/tags)

    window.addEventListener('message', this.handleChildEvents)
  }

  handleChildEvents(event) {
    const childOrigin = 'https://flow.formsort.com'

    if (event.origin !== childOrigin) return
    if (event.data !== 'childReady' && !event.data.event) return

    if (event.data === 'childReady') {
      // Send event that parent is ready
      event.source.postMessage('parentReady', event.origin)
    }

    if (event.data.event) {
      window.dataLayer.push(event.data)
    }
  }
}

export default Join
